import { ComponentProps, useState } from "react";
import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ReportSettingsModal from "../ReportSettingsModal";
import StrategyTaxStateSetting from "../StrategyTaxStateSetting";
import StrategyFederalTaxSetting from "../StrategyFederalTaxSetting";
import SummaryFormulaSettings from "./SummaryFormulaSettings";
import Bucket3IncomeTypesSetting from "./Bucket3IncomeTypesSetting";

/**
 * The Strategy Report's one Settings view, opened from the gear in the
 * filters' bottom-right corner. It gathers every setting the cards used to carry
 * on their own gears -- the summary's formulas and the Keep card's tax rates
 * -- so each can be set before the first Calculate, while the cards below are
 * still hidden (task 5001). All of them are sent with Calculate.
 *
 * Tax Savings sits to the right of Summary, split by a vertical divider, so
 * the view has room below for more settings; on a phone-width screen the two
 * stack, Tax Savings under Summary (task 6136). Bucket 3 spans the full
 * width beneath them (task 6137).
 */
const StrategyReportSettings = (
  formulaProps: ComponentProps<typeof SummaryFormulaSettings>,
) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title="Report settings">
        <IconButton
          aria-label="Report settings"
          size="small"
          onClick={() => setOpen(true)}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <ReportSettingsModal
        open={open}
        onClose={() => setOpen(false)}
        title="Report Settings"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
              Summary
            </Typography>
            <SummaryFormulaSettings {...formulaProps} />
          </Box>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: "none", sm: "block" } }}
          />
          <Divider sx={{ display: { xs: "block", sm: "none" } }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
              Tax Savings
            </Typography>
            <StrategyTaxStateSetting />
            <StrategyFederalTaxSetting />
          </Box>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
          Bucket 3 Income
        </Typography>
        <Bucket3IncomeTypesSetting />
      </ReportSettingsModal>
    </>
  );
};

export default StrategyReportSettings;
